PegasusTemplate.ApplicationRoute = Ember.Route.extend({
  setupController:function(){
    this._super();
  },
  actions: {
    broadcastHiddenState: function(state){
      this.controllerFor('frameCommManager').broadcastHiddenState( state );
    },

    loadTemplate: function(){
      var template,
        hostObject;

      //try {
      template = PegasusTemplate.IOManager.createFromExternal();
      //} catch(e){
        //Em.warn('could not extract template');
        //PegasusTemplate.stateMachine.transitionTo(null);
        //return;
      //}

      if( !template ){ return false; }

      hostObject = template.data;

      var defaults = {
        facebook_url: 'http://www.facebook.com/',
        twitter_url: 'http://www.twitter.com/',
        pinterest_url: 'https://www.pinterest.com/',
        google_url: 'https://plus.google.com/',
        instagram_url: 'https://www.instagram.com/',
        snapchat_url: 'https://www.snapchat.com/',
        tumblr_url: 'https://www.tumblr.com/',
        linkedin_url: 'https://www.linkedin.com/company/',
        youtube_url: 'https://www.youtube.com/user/'
      };

      var socialUrlProxy = PegasusTemplate.SocialFollowUrlProxy.create(
        $.extend( defaults, {
          pinterest_url: hostObject.pinterest_url,
          facebook_url: hostObject.facebook_url,
          linkedin_url: hostObject.linkedin_url,
          google_url: hostObject.google_url,
          youtube_url: hostObject.youtube_url,
          twitter_url: hostObject.twitter_url,
          instagram_url: hostObject.instagram_url,
          snapchat_url: hostObject.snapchat_url,
          tumblr_url: hostObject.tumblr_url
        })
      );

      this.controllerFor('socialFollow').setProperties({
        content: socialUrlProxy
      });

      if( template.model.get('isDirty') ){
        template.model.save();
      }

      Em.run.next(PegasusTemplate.stateMachine, 'send', 'contentInitialized', template);
    },

    templateLoaded: function(){
      this.controllerFor('frameCommManager').templateLoaded();
    },

    enteredIdleState: function(){
      this.controllerFor('frameCommManager').send('enteredIdleState');
    },

    showWidgetCodeModal: function(){
      this.controllerFor('frameCommManager').send('requestWidgetCode');
    },

    externallyEncodeImage: function(url) {
      this.controllerFor('frameCommManager').send('requestExternalImageTransformation', url);
    },
    escape: Em.K,
    saveNewContactList: function(name){
      this.controllerFor('frameCommManager').send('createContactList', {
        name: name
      });
    },
    exitReplacer: function(){
      $('.replace-overlay').removeClass('open');
    },
    touchedBlock: function(){
      this.controllerFor('toolbar').set('touched', true);
    },
    saveContent: function(){
      PegasusTemplate.lookupController('application').setProperties({
        savedContent: PegasusTemplate.IOManager.generateOutput()
      });
    },
    didLoadEditor: function(){
      this.controllerFor('frameCommManager').say(window.parent, {
        method: 'didLoadEditor',
        payload: {}
      });
    },
    saveAndExit: function(){
      var self = this;

      this.controllerFor('template').set('isSaving', true);

      PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', function(){
        Em.run.scheduleOnce('afterRender', self, function(){
          // Prevent autosave once the user has initiated a transfer
          this.controllerFor('autoSave').set('lastVersion', Em.get(PegasusTemplate.CommandManager, 'instance.version'));
          var handoffObject = PegasusTemplate.IOManager.generateOutput(true);
          this.controllerFor('frameCommManager').set('handoffPayload', handoffObject);

          this.controllerFor('frameCommManager').say(window.parent, {
            method: 'saveAndExit',
            payload: handoffObject
          });
        });
      });

      PegasusTemplate.stateMachine.send('didFinishEditing');
    },
    saveSnapshot: function(){
      var handoffObject = PegasusTemplate.IOManager.generateOutput(true);
      this.controllerFor('frameCommManager').set('snapshotPayload', handoffObject);

      this.controllerFor('frameCommManager').say(window.parent, {
        method: 'saveSnapshot',
        payload: handoffObject
      });
    },
    saveAndContinue: function(){
      var self = this;

      this.controllerFor('template').set('isSaving', true);

      PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', function(){
        Em.run.scheduleOnce('afterRender', self, function(){
          // Prevent autosave once the user has initiated a transfer
          this.controllerFor('autoSave').set('lastVersion', Em.get(PegasusTemplate.CommandManager, 'instance.version'));

          var handoffObject = PegasusTemplate.IOManager.generateOutput(true);
          this.controllerFor('frameCommManager').set('handoffPayload', handoffObject);

          this.controllerFor('frameCommManager').say(window.parent, {
            method: 'saveAndContinue',
            payload: handoffObject
          });
        });
      });

      PegasusTemplate.stateMachine.send('didFinishEditing');
    },
    saveAndSendTestEmail: function(){
      this.controllerFor('frameCommManager').prepareSendTestEmail();
      this.send('saveAndContinue');
    },
    saveAndGoToTestKit: function(){
      this.controllerFor('frameCommManager').prepareGoToTestKit();
      this.send('saveAndContinue');
    },
    tryUpgrading: function(){
      this.controllerFor('frameCommManager').requestUpgradeModal();
    },
    didSave: Ember.K,
    didSendTest: function(){
      this.controllerFor('template').set('isSaving', false);
      PegasusTemplate.set('status', 'editing');
      PegasusTemplate.stateMachine.transitionTo('idling');
    },
    setEditorStatusToEditing: function(){
      PegasusTemplate.set('status', 'editing');
    },
    showTemplate: function(template){
      this.transitionTo('template', template.model);
    },
    clearRows: function(){
      this.controllerFor('toolbar').send('clearRows');
    },
    gotoLoading: function(){
      this.transitionTo('loading');
    },

    validateFields: function(){
    },

    showFeedback: function(){
      this.controllerFor('frameCommManager').send('provideFeedback');
    },

    showEditorHelpVideo: function(){
      this.controllerFor('frameCommManager').send('showEditorHelpVideo');
    },

    showHelp: function(){
      this.controllerFor('application').set('shouldShowHelpMenu', true);
    },

    setContext: function(context){
      PegasusTemplate.setProperties({
        nextCopy: context.nextCopy,
        blockedFromSendEmail: context.blockedFromSendEmail,
        implementorLogo: context.implementorLogo
      });
    },

    displayConfirmationError: function(args) {
      if(PegasusTemplate.stateMachine.currentState.name == 'confirming') {
        var errors = args.errors, showConfirmationModal = args.displayModal;
        var activation_error = false, keys = [];

        for(var i in errors) {
          keys.push(i);
        }

        // We want to show the modal only on the last step of AR confirmation
        if(keys.length == 1 &&
          errors.message) {

          errors.message.forEach(function(err) {
            if(err == Em.I18n.t('activerecord.errors.models.autoresponder.attributes.user.not_confirmed')) {
              activation_error = true;
            }
          });
        }

        if(activation_error) {
          // We need this in order for editor to allow edition after error
          PegasusTemplate.stateMachine.transitionTo('idling');

          // Show email account verification modal
          showConfirmationModal();
        }
      }
    },

    deleteSavedImage: function(image) {
      var id = parseInt(
        image.src.split(/\/images\//).get('lastObject'),
        10
      );

      if ( isNaN( id ) ) { return; }

      this.controllerFor('frameCommManager').deleteSavedImage(id);
    }

  }
});

PegasusTemplate.IndexRoute = Ember.Route.extend({
  redirect: function(){
    if ( !Em.testing ) {
      this.transitionTo( 'loading' );
    }
  }
});
